
import React from 'react';

interface DynamicMetaTagsProps {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
}

export const DynamicMetaTags: React.FC<DynamicMetaTagsProps> = () => {
  // Component disabled in favor of static meta tags in index.html
  return null;
};
